import type { SeatsIoConfig as GQLItem } from '../../../generated/api.graphql';
import { take } from '../../../util/takePayload';

export type SeatsIoConfig = {
  secretKey: string;
  publicKey: string;
  region: string;
};

export const fromGql = (item: GQLItem): SeatsIoConfig =>
  take<SeatsIoConfig>(item, 'secretKey', 'publicKey', 'region');
